<template>
  <div v-if="show" class="text-center" :class="{'onModal' : onModal}" id="overlay">
    <span id="loading" class="pt-5 mt-5">
      <img src="../../img/loading.gif" alt="Now Loading..." />
      <p class="text-center">Now Loading...</p>
    </span>
  </div>
</template>

<style scoped>
#overlay {
  background-color: rgba(255, 255, 255, 0.90);
  z-index: 9999;
  /* top: 0; */
  left: 0;
  height: 100vh;
  width: 100vw;
  position: fixed;
  margin: 0;
}
.onModal {
  min-width: 1000px;
  min-height: 5000px;
  margin: 0px -450% !important;
  padding: 0px 500%;
}
#loading {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    margin: auto;
    width: 128px;
    height: 64px;
}
</style>

<script>

export default {
  name: "loading",
  props: {
  },
  data() {
    return {
      show: true,
      onModal: false,
    }
  },
  watch: {
    '$route': function (to, from) {
      this.show = true
    },
    'show': function (val) {
      this.switchScroll()
    },
  },
  mounted() {
    this.switchScroll()
  },
  methods: {
    switchScroll(){
      var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'
      if(this.show){
        //PC用
        $(document).on(scroll_event,function(e){e.preventDefault()})
        //SP用
        $(document).on('touchmove.noScroll', function(e) {e.preventDefault()})
      } else {
        //PC用
        $(document).off(scroll_event)
        //SP用
        $(document).off('.noScroll')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/assets/js/components/Loading.vue